import User from "admin/types/interfaces/user";

export const getUserInitials = (user: User) => {
  if (!user.full_name) {
    return "U";
  }
  return user.full_name.split(" ")[0][0] + user.full_name.split(" ")[1][0];
};

// Emails are case-insensitive identifiers; the access controller stores them case-preserving
// (CITEXT) but normalizes user: principals to lowercase, so grant principals and user-object
// emails can differ in case. Always match emails case-insensitively.
export const findUserByEmail = (users: User[], email: string): User | undefined => {
  const target = email.toLowerCase();
  return users.find((u) => u.email.toLowerCase() === target);
};

export const getUserNameByEmail = (email: string, users: User[]): string => {
  return findUserByEmail(users, email)?.full_name || email;
};

// Canonical grant principal for a user email. The id is lowercased so locally built
// principals match the server's normalized form (the access controller lowercases every
// user: id at the /authz boundary). user-tag: principals are case-sensitive — do not
// build them with this helper.
export function userPrincipal(email: string): string {
  return `user:${email.toLowerCase()}`;
}
